import styled from '@emotion/styled'
import { metrics } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'

export interface StyledVideoContentsProps {
    showVideo: boolean
}

export const StyledVideoContents = styled('div')<StyledVideoContentsProps>(
    ({ theme, showVideo }) => {
        // vertical spacing is set to the same values as paragraphs
        const verticalSpacing =
            theme.kind === 'thewest'
                ? calcRem(metrics.thewest.textMargin / 2)
                : calcRem(metrics.perthnow.textMargin)
        return {
            display: showVideo ? 'block' : 'none',
            margin: `0 0 ${verticalSpacing} 0`,
        }
    }
)
